import React, { Component } from "react";
import ZoomVideo, {
  ConnectionState,
  ReconnectReason,
  VideoQuality,
} from "@zoom/videosdk";
import {
  checkMemberVideoPermission,
  CheckValue,
  getMediaPermission,
} from "../../../services/CommonFunction";
import { ErrorUI } from "../../../components/UI/Modals/Modals";
import { changeVolume } from "../../../components/UI/InputRange/InputRange";
import { messageService } from "../../../services/subscriberService";
import { staticVar } from "../../../services/Constants";
import axios from "../../../axios";
import ApiURL from "../../../services/ApiURL";

class ZoomSDK extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clas: props.clas,
      zmClient: ZoomVideo.createClient(),
      stream: null,
      canvas: null,
      temp: [],
      isUpdatingCanvas: false,
      deviceId: null,
      userId: {},
      showUser: {},
      audioDecode: false,
      audioEncode: false,
      isLocalStreamStarted: false,
      isWindowResizingStopped: false,
      isWindowResizing: false,
      isParticipantsCanvasHidden: false,
      isCoachVideoStarted: false,
      coachZoomId: null,
      activeSpeaker: null,
      OvCameraId: null, // current selected camera id
      OvAudioId: null, // current selected audio id
      width: 217,
      height: 453,
    };
  }

  get getZoomData() {
    const { stream } = this.state;
    return {
      ...this.state,
      sessionStatus: CheckValue(stream),
      isCameraEnabled: CheckValue(stream) ? this.getLocalVideoStatus() : false,
      isAudioEnabled: CheckValue(stream) ? !stream.isAudioMuted() : false,
    };
  }

  get getAudioDeviceList() {
    const list = this.state.stream
      .getMicList()
      .filter((el) => el.deviceId !== "default");
    return {
      list,
      firstDevice: list.length ? list[0].deviceId : "",
    };
  }

  get getSpeakerDeviceList() {
    const list = this.state.stream.getSpeakerList();
    return {
      list,
      firstDevice: list.length ? list[0].deviceId : "",
    };
  }

  get getVideoDeviceList() {
    const list = this.state.stream.getCameraList().map((el) => {
      if (el.label.includes(staticVar.defaultCameraName)) {
        el.label = staticVar.defaultCameraName;
      }
      return el;
    });
    return {
      list,
      firstDevice: list.length ? list[0].deviceId : "",
    };
  }

  zoomState(obj) {
    this.setState(obj);
  }

  getpermission = () => {
    staticVar.permission = true;
    const { video_conference_data } = this.props;
    getMediaPermission({ audio: true, video: true }, null, 0, false).then(
      async (res) => {
        if (res.status) {
          this.joinMetting(video_conference_data);
        } else {
          ErrorUI(
            "Kindly allow access to your camera and microphone in your settings and try again."
          );
        }
      }
    );
  };
  componentDidMount() {
    this.state.zmClient.init("en-US", "CDN");
    const { id } = this.props;
    Object.keys(sessionStorage).forEach((el) => {
      sessionStorage.removeItem(el);
    });
    if (staticVar.permission) {
      this.getpermission();
    } else {
      ErrorUI(staticVar.textMsg, null, {}, this.getpermission);
    }

    if (CheckValue(localStorage.getItem("setVolume"))) {
      changeVolume(parseInt(localStorage.getItem("setVolume"), 10), id);
    } else {
      changeVolume(100, id);
    }
    window.addEventListener("resize", this.displayWindowSize);
  }

  componentDidUpdate(prevState, prevProps) {
    // console.log(prevState.OvCameraId,prevProps.OvCameraId,this.state.OvCameraId);
  }

  componentWillUnmount() {
    this.leave();
  }

  displayWindowSize = () => {
    console.log("displayWindowSize");
    // Get width and height of the window excluding scrollbars
    clearTimeout(this.resizeFuncId);
    // const { isWindowResizing } = this.state;
    // if(CheckValue(isWindowResizing && !isWindowResizing)){
    //     console.log('isWindowResizing', isWindowResizing);
    //     this.clearVideoCanvas();
    // }
    if (!this.state.isWindowResizing) {
      this.setState({ isWindowResizing: true });
    }
    this.resizeFuncId = setTimeout(() => {
      this.setState({ isWindowResizingStopped: true });
      // const { showUser } = this.state;
      // if(CheckValue(showUser) && Object.values(this.state.showUser).length) {
      //     Object.values({...showUser}).forEach((el,index) => {
      //         if (el.data.isVideoStarted ) {
      //             this.stopAttendeeVideo(el.data.userId);
      //         }
      //         delete showUser[el.data.user_id];
      //     });
      // }
      // this.clearVideoCanvas();
      // this.updateCanvas()
    }, 1000);
  };

  get getZoomData() {
    const { stream } = this.state;
    return {
      ...this.state,
      sessionStatus: CheckValue(stream),
      isCameraEnabled: CheckValue(stream) ? this.getLocalVideoStatus() : false,
      isAudioEnabled: CheckValue(stream) ? !stream.isAudioMuted() : false,
    };
  }

  generateZoomToken = () => {
    const { roomDatas } = this.props;
    return axios
      .post(ApiURL._generateZoomToken, { activity_id: roomDatas.activity_id })
      .then((res) => res.data.data);
  };

  joinMetting = (data) => {
    const { zmClient, showUser } = this.state;
    const { userActivityData } = this.props;
    const video_conference_data = userActivityData.video_conference_object;
    messageService.sendMessage(true);
    zmClient
      .join(
        video_conference_data.sessionId,
        video_conference_data.signature,
        JSON.stringify({
          user_id: userActivityData.user_id,
          timestamp: +new Date(),
        }),
        ""
      )
      .then(async () => {
        await this.setState({ stream: zmClient.getMediaStream() });
        messageService.sendMessage(false);
        this.setState({ isWindowResizing: true });
        this.addMeetingEvents("on");
        setTimeout(() => {
          zmClient.getAllUser().forEach((user) => {
            this.userAdd([{ ...user }]);
          });
        }, 1000);

        setTimeout(async () => {
          this.setState({ isWindowResizingStopped: true });
        }, 1000);
        // setTimeout(async () => {
        //     if(CheckValue(this.state.stream)) {
        //         this.state.stream.startAudio();
        //     }
        // }, 1000);
      })
      .catch((error) => {
        messageService.sendMessage(false);
        console.log(error);
        ErrorUI(
          "An error occured while joining, please try again.",
          () => this.joinMetting(data),
          {
            cancelText: "Cancel",
            submitText: "Retry",
          }
        );
      });
  };

  isJson = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return {
        user_id: str,
        timestamp: +new Date(),
      };
    }
    return JSON.parse(str);
  };

  connectionListner = (payload) => {
    console.log("connection-change", payload);
    if (payload.state === ConnectionState.Reconnecting) {
      const { reason, subsessionName } = payload;
      if (reason === ReconnectReason.Failover) {
        console.log("Session Disconnected,Try to reconnect");
      } else if (
        reason === ReconnectReason.JoinSubsession ||
        reason === ReconnectReason.MoveToSubsession
      ) {
        console.log(`Joining ${subsessionName}...`);
      } else if (reason === ReconnectReason.BackToMainSession) {
        console.log("Returning to Main Session...");
      }
    } else if (payload.state === ConnectionState.Connected) {
      console.log("connected");
    } else if (payload.state === ConnectionState.Closed) {
      console.log("closed");
      // setStatus('closed');
      // dispatch({ type: 'reset-media' });
      if (payload.reason === "ended by host") {
        console.log("ended by host");
      }
    }
  };

  mediaSdkChangeListner = (payload) => {
    const { stream } = this.state;
    const { action, type, result } = payload;
    if (type === "audio" && result === "success") {
      if (action === "encode") {
        this.setState({ audioEncode: true });
      } else if (action === "decode") {
        this.setState({ audioDecode: true });
      }
    } else if (
      type === "video" &&
      result === "success" &&
      CheckValue(localStorage.getItem("isCameraEnable")) &&
      !this.getLocalVideoStatus()
    ) {
      this.enableDisableAudioCamera("camera");
    }
    if (this.state.audioDecode && this.state.audioEncode) {
      const mediaAudio = document.getElementById("mediaAudio");
      const mediaVideo = document.getElementById("mediaVideo");
      if (CheckValue(mediaVideo) && !mediaVideo.muted) {
        mediaVideo.volume = 1;
      }
      if (CheckValue(mediaAudio) && !mediaAudio.muted) {
        mediaAudio.volume = 1;
      }
      // ErrorUI(staticVar.textMsg, null, {}, () => {
      stream
        .startAudio()
        .then((result) => {
          stream.muteAudio();
        })
        .catch((error) => {
          console.log(error);
          setTimeout(() => {
            stream.muteAudio();
          }, 1000);
        });
      // })
    }
  };

  addMeetingEvents(status) {
    const { zmClient, stream } = this.state;
    // Occurs when new participant join the meeting
    zmClient[status]("user-added", this.userAddListener);
    zmClient[status]("connection-change", this.connectionListner);
    zmClient[status]("share-audio-changed", (payload) => {
      console.log("share-audio-changed", payload);
    });
    zmClient[status]("user-updated", (payload) => {
      // console.log('user-update',payload);
      if (payload.length) {
        const { allUsers } = this.props;
        const { userId, activeSpeaker } = this.state;
        payload.forEach((el) => {
          const id = userId[el.userId];
          if (allUsers.hasOwnProperty(id) && CheckValue(el.muted)) {
            allUsers[id].muted = el.muted;
            if (
              el.muted &&
              CheckValue(activeSpeaker) &&
              activeSpeaker.userId === el.userId
            ) {
              this.setState({ activeSpeaker: null });
            }
          }
        });
      }
    });

    // Occurs when the participants leave the meeting
    zmClient[status]("user-removed", this.userRemoveListener);
    zmClient[status]("video-dimension-change", (payload) => {
      console.log("video-dimension-change", payload);
    });
    zmClient[status]("video-capturing-change", this.videoCaptureChangeListener);
    zmClient[status]("share-audio-change", (payload) => {
      console.log("share-audio-change", payload);
    });
    zmClient[status]("main-session-user-updated", (payload) => {
      console.log("main-session-user-updated", payload);
    });
    zmClient[status]("media-sdk-change", (payload) => {
      console.log("media-sdk-change", payload);
    });
    zmClient[status]("video-detailed-data-change", (payload) => {
      console.log("video-detailed-data-change", payload);
    });

    // Occurs when the properties of the participants updated.
    // zmClient.on("user-updated", (payload) => {
    //   console.log(`user-updated:`, payload);
    // });
    // Occurs when other participants start/stop video
    zmClient[status]("peer-video-state-change", this.videoStateChangeListener);
    zmClient[status]("auto-play-audio-failed", () => {
      console.log("auto play failed, waiting for a user interaction");
    });
    zmClient[status]("audio-statistic-data-change", (payload) => {
      console.log("emit", payload);
    });

    zmClient.on("media-sdk-change", this.mediaSdkChangeListner);
    // zmClient[status]('current-audio-change', (payload) => {
    //     if(payload.action==='join'){
    //         console.log('Joined by ',payload.type);
    //         if(!CheckValue(localStorage.getItem('isAudioEnable'))) {
    //             setTimeout(() => {
    //                 this.state.stream.muteAudio();
    //             }, 200);
    //         }
    //     }
    // });
    zmClient[status]("device-change", () => {
      // console.log('device-change');
      // this.setDeviceId();
    });
    zmClient[status]("active-speaker", (payload) => {
      console.log(payload);
      if (payload.length) {
        const data = this.isJson(payload[0].displayName);
        const id = data.user_id.split("_");
        if (
          id.length < 2 &&
          (!CheckValue(this.state.activeSpeaker) ||
            this.state.activeSpeaker.userId !== payload[0].userId)
        ) {
          this.setState((prevState) => ({
            activeSpeaker: {
              userId: payload[0].userId,
              user_id: id[0],
            },
          }));
          setTimeout(() => {
            this.setState({ activeSpeaker: null });
          }, 1500);
        }
      }
    });
  }

  userAddListener = (payload) => {
    console.log("userAddListener");
    this.userAdd(payload, true);
  };

  userAdd = (payload, status = false) => {
    const { userId } = this.state;
    const { allUsers, coachData } = this.props;
    payload.map((el) => {
      const data = this.isJson(el.displayName);
      const id = data.user_id.split("_");
      if (allUsers.hasOwnProperty(id[0])) {
        if (CheckValue(allUsers[id[0]].timestamp)) {
          if (data.timestamp < allUsers[id[0]].timestamp) {
            return;
          }
        }
        allUsers[id[0]].timestamp = data.timestamp;
        allUsers[id[0]].userId = el.userId;
        allUsers[id[0]]["stream"] = el.bVideoOn;
      } else if (coachData.user_id === id[0]) {
        let key = id[1] + "_timestamp";
        if (CheckValue(coachData[key])) {
          if (data.timestamp < coachData[key]) {
            return;
          }
        }

        coachData[key] = data.timestamp;
        if (el.bVideoOn) {
          this.startCoachVideo(el.userId);
        }
      } else if (coachData.waitingRoom_open_by === id[0]) {
        let key = id[1] + "_owner_timestamp";
        if (CheckValue(coachData[key])) {
          if (data.timestamp < coachData[key]) {
            return;
          }
        }

        coachData[key] = data.timestamp;
        if (el.bVideoOn) {
          this.startCoachVideo(el.userId);
        }
      }
      if (!userId.hasOwnProperty(id[0])) {
        userId[el.userId] = id[0];
      }
    });
  };
  userRemoveListener = (payload) => {
    console.log("userRemoveListener", payload);
    const { userId } = this.state;
    const { allUsers, coachData } = this.props;
    payload.map((el) => {
      if (userId.hasOwnProperty(el.userId)) {
        const id = userId[el.userId];
        if (allUsers.hasOwnProperty(id)) {
          if (allUsers[id].userId === el.userId) {
            if (allUsers[id].isVideoStarted) {
              this.stopAttendeeVideo(el.userId);
            }
            delete allUsers[id].userId;
          }
        } else if (
          coachData.userId === el.userId ||
          coachData.ownerUserId === el.userId
        ) {
          this.stopCoachVideo(el.userId);
        }
        delete userId[el.userId];
      }
    });
  };
  videoStateChangeListener = (payload) => {
    console.log("videoStateChangeListener", payload);
    const { allUsers, isOngoingRoom, coachData } = this.props;
    const { userId } = this.state;
    if (userId.hasOwnProperty(payload.userId)) {
      const id = userId[payload.userId];
      if (allUsers.hasOwnProperty(id)) {
        //allUsers[id]['stream'] = payload.action === 'Start';
        if (payload.action === "Stop" && allUsers[id].isVideoStarted) {
          console.log("stop-video");
          this.stopAttendeeVideo(payload.userId);
        }
        if (
          isOngoingRoom &&
          !checkMemberVideoPermission(
            allUsers[id].participant_video_visibility_in_attempt
          )
        ) {
          return;
        }

        allUsers[id]["stream"] = payload.action === "Start";
      } else if (
        coachData.user_id === id ||
        coachData.waitingRoom_open_by === id
      ) {
        if (payload.action === "Start") {
          this.startCoachVideo(payload.userId);
        } else {
          this.stopCoachVideo(payload.userId);
        }
      } else if (payload.action === "Stop") {
        this.stopAttendeeVideo(payload.userId);
      }
    }
  };

  videoCaptureChangeListener = (payload) => {
    console.log("videoCaptureChangeListener", payload);
    const { allUsers } = this.props;
    const { userId, zmClient } = this.state;
    const userInfo = zmClient.getCurrentUserInfo();
    if (!CheckValue(userInfo)) {
      return;
    }
    const zoomUserId = userInfo.userId;
    if (userId.hasOwnProperty(zoomUserId)) {
      const id = userId[zoomUserId];
      allUsers[id]["stream"] = payload.state === "Started";
      if (payload.state === "Stopped" && allUsers[id].isVideoStarted) {
        console.log("stop-video");
        this.stopAttendeeVideo(payload.userId);
      }
    }
  };

  startAttendeeVideo = (zoomUserId, index) => {
    const { stream, userId } = this.state;
    const { allUsers, isOngoingRoom } = this.props;
    const id = userId[zoomUserId];
    if (
      CheckValue(stream) &&
      allUsers.hasOwnProperty(id) &&
      !allUsers[id].isVideoStarted
    ) {
      const userDiv = document.getElementById(id);
      const canvas = document.querySelector("#participants-canvas");
      if (CheckValue(canvas) && CheckValue(userDiv)) {
        console.log("startAttendeeVideo", zoomUserId);
        const { finalWidth, finalHeight, x, y, status } = !isOngoingRoom
          ? this.getVideoDimensions(id, index, userDiv, canvas)
          : this.getDimension(id, index);
        if (!status) {
          return;
        }
        allUsers[id].isVideoStarted = true;
        stream
          .renderVideo(
            canvas,
            zoomUserId,
            finalWidth,
            finalHeight,
            x,
            y,
            1,
            zoomUserId
          )
          .then((res) => {
            console.log("success  -  startAttendeeVideo");
          })
          .catch((err) => {
            allUsers[id].isVideoStarted = false;
            // setTimeout(() => {
            //   this.startAttendeeVideo(zoomUserId, index);
            // }, 1000);
            console.log("error", err);
          });
      }
    }
  };

  stopAttendeeVideo = (zoomUserId) => {
    const { allUsers } = this.props;
    const { stream, userId } = this.state;
    const id = userId[zoomUserId];
    if (CheckValue(zoomUserId)) {
      if (
        CheckValue(stream) &&
        CheckValue(document.querySelector("#participants-canvas"))
      ) {
        stream
          .stopRenderVideo(
            document.querySelector("#participants-canvas"),
            zoomUserId,
            zoomUserId
          )
          .then((res) => {
            console.log("success  -  stopAttendeeVideo");
            if (
              CheckValue(id) &&
              allUsers.hasOwnProperty(id) &&
              allUsers[id].isVideoStarted
            ) {
              allUsers[id].isVideoStarted = false;
            }
          })
          .catch((err) => {
            console.log("error", err);
            setTimeout(() => {
              this.stopAttendeeVideo(zoomUserId);
            }, 1000);
            this.stopAttendeeVideo(zoomUserId);
          });
      } else {
        if (
          CheckValue(id) &&
          allUsers.hasOwnProperty(id) &&
          allUsers[id].isVideoStarted
        ) {
          allUsers[id].isVideoStarted = false;
        }
      }
    }
  };

  updateAttendeeVideo = (zoomUserId, index) => {
    new Promise((resolve) => setTimeout(resolve, 1000)).then(() => {
      console.log("updateAttendeeVideo");
      const { stream, userId } = this.state;
      const { allUsers, isOngoingRoom } = this.props;
      const id = userId[zoomUserId];

      if (
        CheckValue(stream) &&
        allUsers.hasOwnProperty(id) &&
        allUsers[id].isVideoStarted
      ) {
        // index = 2;
        const userDiv = document.getElementById(id);
        const canvas = document.querySelector("#participants-canvas");
        if (CheckValue(userDiv) && CheckValue(canvas)) {
          const { finalWidth, finalHeight, x, y, status } = !isOngoingRoom
            ? this.getVideoDimensions(id, index, userDiv, canvas)
            : this.getDimension(id, index);
          if (!status) {
            return;
          }
          console.log(finalWidth, finalHeight, x, y, status);
          stream
            .adjustRenderedVideoPosition(
              canvas,
              zoomUserId,
              finalWidth,
              finalHeight,
              x,
              y,
              zoomUserId
            )
            .then((res) => {
              console.log("success  -  updateAttendeeVideo");
            })
            .catch((err) => {
              // this.updateAttendeeVideo(zoomUserId,index);
              setTimeout(() => {
                this.startAttendeeVideo(zoomUserId, index);
              }, 1000);
              console.log("error", err);
            });
        }
      }
    });
  };

  getVideoDimensions = (id, index, userDiv, canvas) => {
    const { isWindowResizing, isUpdatingCanvas } = this.state;
    if (isWindowResizing || isUpdatingCanvas) {
      return {
        finalWidth: 0,
        finalHeight: 0,
        x: 0,
        y: 0,
        status: false,
      };
    }
    const userDivDim = userDiv.getBoundingClientRect();
    const canvasDim = canvas.getBoundingClientRect();
    const x = userDivDim.x - canvasDim.x + 4;
    const y = canvasDim.bottom - userDivDim.bottom + 3;
    const finalWidth = userDivDim.width - 6;
    const finalHeight = userDivDim.height - 6;
    if (y < 0 || canvasDim.height < y + finalHeight) {
      if (!isUpdatingCanvas) {
        this.setState({ isWindowResizing: true });
        setTimeout(() => {
          this.setState({ isWindowResizingStopped: true });
        }, 1000);
        return {
          finalWidth: 0,
          finalHeight: 0,
          x: 0,
          y: 0,
          status: false,
        };
      }
    }
    return {
      finalWidth: finalWidth,
      finalHeight: finalHeight,
      x: x,
      y: y,
      status: x > 0 || y > 0,
    };
  };

  getDimension = (id, index) => {
    // index = 1;
    const { isWaitingRoom } = this.props;
    const { isWindowResizing, isUpdatingCanvas } = this.state;
    if (isWindowResizing || isUpdatingCanvas) {
      return {
        finalWidth: 0,
        finalHeight: 0,
        x: 0,
        y: 0,
        status: false,
      };
    }
    if (isWaitingRoom || true) {
      const userDiv = document.getElementById(id);
      const canvas = document.querySelector("#participants-canvas");
      const { width, height } = canvas.getBoundingClientRect();
      const userDivData = userDiv.getBoundingClientRect();
      let status = true;
      const finalHeight = Math.round(userDivData.height);
      console.log(userDivData.height, finalHeight);
      const finalWidth = Math.round(userDivData.width) - 4;
      const x = 2;
      let gap = 10;
      if (!isWaitingRoom) {
        gap = 11;
      }
      // console.log('getDimension=====', height, tempIndex, (finalHeight + gap));
      const y = height - (index * (finalHeight + gap) + finalHeight);
      if (y < 0 || height < y + finalHeight) {
        if (!isUpdatingCanvas) {
          this.setState({ isWindowResizing: true });
          setTimeout(() => {
            this.setState({ isWindowResizingStopped: true });
          }, 1000);
          return {
            finalWidth: 0,
            finalHeight: 0,
            x: 0,
            y: 0,
            status: false,
          };
        }
      }
      const widthRatio = 1 || 1920 / width;
      const heightRatio = 1 || 1080 / height;
      const newX = Math.round(x * heightRatio);
      let newY = Math.round(y * widthRatio);

      if (newX < 0 || newY < 0) {
        status = false;
      }
      return {
        finalWidth: Math.round(finalWidth * widthRatio),
        finalHeight: Math.round(finalHeight * heightRatio),
        x: newX < 0 ? 0 : newX,
        y: newY < 0 ? 0 : newY,
        status,
      };
    } else {
      const userDiv = document.getElementById(id);
      const userDivData = userDiv.getBoundingClientRect();
      const canvas = document.querySelector("#participants-canvas");
      const { width, height } = canvas.getBoundingClientRect();
      let tempIndex = index + 1;
      let status = true;
      const finalHeight = Math.round(userDivData.height);
      const finalWidth = Math.round(userDivData.width) - 4;
      const x = 2;
      let gap = index * 10;
      // console.log(height, tempIndex, finalHeight )
      if (height < tempIndex * (finalHeight + gap)) {
        status = false;
        if (!isUpdatingCanvas) {
          this.setState({ isWindowResizing: true });
          setTimeout(() => {
            this.setState({ isWindowResizingStopped: true });
          }, 1000);
          return {
            finalWidth: 0,
            finalHeight: 0,
            x: 0,
            y: 0,
            status: false,
          };
        }
      }
      const y = height - (index * finalHeight + gap + finalHeight);
      const widthRatio = 1 || 1920 / width;
      const heightRatio = 1 || 1080 / height;
      const newX = Math.round(x * heightRatio);
      const newY = Math.round(y * widthRatio);
      // console.log('getDimension', isUpdatingCanvas, index, "canvas width = ", width, "canvas height = ",  height, "div width = ", finalWidth, "div height = ", finalHeight, x, y)
      if (newX < 0 || newY < 0) {
        status = false;
      }
      return {
        finalWidth: Math.round(finalWidth * widthRatio),
        finalHeight: Math.round(finalHeight * heightRatio),
        x: newX < 0 ? 0 : newX,
        y: newY < 0 ? 0 : newY,
        status,
      };
    }
  };

  startStopCoachVideo(status) {
    const { coachZoomId } = this.state;
    if (CheckValue(coachZoomId)) {
      if (status) {
        this.startCoachVideo(coachZoomId);
      } else {
        this.stopCoachVideo(coachZoomId);
      }
    }
  }

  stopRenderingParticipantsVideos(status) {
    this.setState({ isParticipantsCanvasHidden: status });
    if (status) {
      this.stopVideosAndClearCanvas();
    }
  }

  stopVideosAndClearCanvas() {
    const { showUser } = this.state;
    if (Object.values(showUser).length) {
      Object.values({ ...showUser }).forEach((el, index) => {
        if (el.data.isVideoStarted) {
          this.stopAttendeeVideo(el.data.userId);
        }
        delete showUser[el.data.user_id];
      });
    }
    this.clearVideoCanvas();
  }

  startCoachVideo = (id) => {
    const { stream, coachData } = this.state;

    if (CheckValue(stream)) {
      const coachCanvas = document.querySelector("#coach_canvas_view");
      let width = 1920,
        height = 1080,
        x = 0,
        y = 0;
      // const width = window.screen.width;
      // const height = window.screen.height;
      // stream.clearVideoCanvas(coachCanvas, "#222222")
      // this.state.stream.updateVideoCanvasDimension(coachCanvas, width, height);
      // stream.renderVideo(coachCanvas, id, width, height, 0, 0, 4).then(res => {
      // })
      console.log(coachCanvas);
      stream.stopRenderVideo(coachCanvas, id);
      stream
        .renderVideo(
          coachCanvas,
          id,
          width,
          height,
          x,
          y,
          VideoQuality.Video_720P
        )
        .then((res) => {
          this.setState({ coachZoomId: id, isCoachVideoStarted: true });
          console.log(
            "success start coach video",
            coachCanvas.getBoundingClientRect().height
          );
        })
        .catch((err) => {
          console.log("start-video-error:- ", err);
          setTimeout(() => {
            this.startCoachVideo(id);
          }, 3 * 1000);
        });
    }
  };

  stopCoachVideo = (id) => {
    const { stream } = this.state;
    console.log("stopCoachVideo");
    if (!CheckValue(id) || !CheckValue(stream)) {
      return;
    }
    const coachCanvas = document.querySelector("#coach_canvas_view");
    stream.stopRenderVideo(coachCanvas, id);
    this.setState({ isCoachVideoStarted: false });
  };

  stopStreming = () => {
    const { stream } = this.state;
    const { isOngoingRoom, pushSocket, socket, userActivityData } = this.props;
    stream
      .stopVideo()
      .then((result) => {
        const userInfo = this.state.zmClient.getCurrentUserInfo();
        const zoomUserId = userInfo.userId;
        this.stopAttendeeVideo(zoomUserId);
        localStorage.removeItem("isCameraEnable");
        if (isOngoingRoom) {
          const obj = { ...userActivityData };
          if (pushSocket) {
            socket.emit("publish_stream_stopped", obj, (data) => {});
          }
        }
      })
      .catch((err) => {
        console.log("stop-streaming-error:- ", err);
      });
  };
  stopAudio = () => {
    const { stream } = this.state;
    if (!stream.isAudioMuted()) {
      stream.muteAudio();
    }
    localStorage.removeItem("isAudioEnable");
  };

  setDeviceId = async (camera_id, audio_id, status = true) => {
    const { stream } = this.state;
    if (!CheckValue(camera_id) || !camera_id.length) {
      camera_id = this.getVideoDeviceList.firstDevice;
    }
    if (!CheckValue(audio_id) || !audio_id.length) {
      audio_id = this.getAudioDeviceList.firstDevice;
    }
    await this.setState({
      OvCameraId: camera_id,
      OvAudioId: audio_id,
      isLocalStreamStarted: true,
    });
    localStorage.setItem("OvCameraId", camera_id);
    localStorage.setItem("OvAudioId", audio_id);
    if (CheckValue(stream)) {
      stream.switchCamera(camera_id);
      stream.switchMicrophone(audio_id);

      setTimeout(() => {
        if (
          !this.getLocalVideoStatus() &&
          (status || CheckValue(localStorage.getItem("isCameraEnable")))
        ) {
          this.enableDisableAudioCamera("camera");
        }
      }, 300);
    }
  };

  enableDisableAudioCamera = async (data) => {
    const { stream, userId, zmClient } = this.state;
    console.log("enableDisableAudioCamera click", stream);
    const userInfo = zmClient.getCurrentUserInfo();
    if (CheckValue(stream) && CheckValue(userInfo)) {
      if (data === "camera") {
        if (this.getLocalVideoStatus()) {
          this.stopStreming();
          this.hideShowMyVideoCard(false);
        } else {
          let data = {
            mirrored: false,
            hd: false,
          };
          // if (this.props.isHangoutRoom) {
          //   data["originalRatio"] = false;
          //   data["captureHeight"] = "740p";
          //   data["captureWidth"] = "260p";
          // }
          stream.startVideo(data).then(() => {
            localStorage.setItem("isCameraEnable", true);
            this.hideShowMyVideoCard(true);
          });
        }
      } else if (data === "audio") {
        if (stream.isAudioMuted()) {
          stream.unmuteAudio();
          localStorage.setItem("isAudioEnable", "true");
        } else {
          this.stopAudio();
          localStorage.removeItem("isUnmuteEnabled");
        }
      }
    }
  };

  muteByDeault = async () => {
    const { stream } = this.state;
    console.log("enableDisableAudioCamera click", stream);
    if (CheckValue(stream)) {
      stream.muteAudio();
    }
  };

  hideShowMyVideoCard = (videoStarted) => {
    const {
      activity_status,
      isOngoingRoom,
      userActivityData,
      pushSocket,
      socket,
    } = this.props;
    // const {userId, zmClient } = this.state;
    console.log("hideShowMyVideoCard");
    if (!CheckValue(activity_status) || !isOngoingRoom) {
      return;
    }
    if (videoStarted) {
      const obj = { ...userActivityData };
      if (pushSocket) {
        socket.emit("publish_stream_started", obj, (data) => {});
      }
    }
  };

  getLocalVideoStatus = () => {
    const { stream } = this.state;
    if (CheckValue(stream)) {
      return stream.isCapturingVideo();
    }
    return false;
  };

  getLocalMuteStatus = () => {
    const { stream } = this.state;
    if (CheckValue(stream)) {
      return stream.isAudioMuted();
    }
    return true;
  };

  getCoachVideoStatus = async () => {
    const { isCoachVideoStarted } = this.state;
    if (CheckValue(isCoachVideoStarted)) {
      return false;
    }
    return isCoachVideoStarted;
  };

  offVideoAudio = async () => {
    const { stream } = this.state;
    if (CheckValue(stream)) {
      if (this.getLocalVideoStatus()) {
        this.stopStreming();
        // Stop video input. If the previously chosen camera has an LED light on,
        // it will turn off indicating the camera is no longer capturing.
      }
      this.stopAudio();
    }
  };

  leaveWRSession = async () => {
    // alert('enter');
    // console.log('enter-session',CheckValue(stream), this.getLocalVideoStatus());
    const { stream, zmClient } = this.state;
    localStorage.removeItem("isStreamPublished");
    this.clearVideoCanvas();
    if (CheckValue(stream) && this.getLocalVideoStatus()) {
      // Stop video input. If the previously chosen camera has an LED light on,
      // it will turn off indicating the camera is no longer capturing.
      this.stopStreming();
    }
    // console.log('enter-session',CheckValue(zmClient));
    if (CheckValue(zmClient)) {
      await this.addMeetingEvents("off");
      zmClient.leave();
    }
  };

  leave = () => {
    const { zmClient } = this.state;
    if (CheckValue(zmClient)) {
      this.addMeetingEvents("off");
      zmClient.leave();
    }
  };

  hostChange = async () => {
    const { stream } = this.state;
    if (CheckValue(stream)) {
      if (
        CheckValue(localStorage.getItem("isCameraEnabled")) ||
        this.getLocalVideoStatus()
      ) {
        this.stopStreming();
      }
      this.stopAudio();
    }
  };

  increaseLength = () => {
    console.log("increaseLength");
    this.setState((prevState) => ({ temp: [...prevState.temp, 1] }));
  };

  updateCanvas = (fromwhere) => {
    // this.setState({ temp: [...this.state.temp,1]});
    this.updatedCanvas(fromwhere);
    // setTimeout(async () => {
    //     await this.setState({ isUpdatingCanvas: false});
    //     Object.values(this.state.showUser).forEach(el => {
    //         if(el.data.stream && el.data.isVideoStarted ) {
    //             this.updateAttendeeVideo(el.data.userId,el.index);
    //         } else if(el.data.stream && !el.data.isVideoStarted ) {
    //             this.startAttendeeVideo(el.data.userId,el.index);
    //         } else if(!el.data.stream && el.data.isVideoStarted ) {
    //             this.stopAttendeeVideo(el.userId);
    //         }
    //     });
    // }, 1000);
  };

  updatedCanvas = (fromwhere) => {
    const { stream } = this.state;
    if (CheckValue(stream)) {
      let canvas = document.querySelector("#participants-canvas");
      let userDiv = document.getElementById("user_container");
      let temp = false;
      if (!CheckValue(userDiv)) {
        userDiv = document.getElementById("tagged_container_div_zoom");
        temp = true;
      }
      if (CheckValue(userDiv)) {
        let clientWidth = userDiv.clientWidth;
        let clientHeight = userDiv.scrollHeight;
        if (temp) {
          clientWidth = clientWidth - 30;
          clientHeight = clientHeight;
          // if
        }
        stream
          .updateVideoCanvasDimension(canvas, clientWidth, clientHeight)
          .then((result) => {
            this.setState({
              width: clientWidth,
              height: clientHeight,
            });
            console.log("OR canvas upated", result, clientWidth, clientHeight);

            this.canvasUpdated();
          })
          .catch((error) => {
            console.error("OR cans update failed ", error);
          });
      } else {
        this.canvasUpdated();
      }
    } else {
      this.canvasUpdated();
    }
  };

  canvasUpdated = () => {
    setTimeout(() => {
      this.setState({ isUpdatingCanvas: false });
      // const canvas = document.querySelector('#participants-canvas');
      // const { width,height } = canvas.getBoundingClientRect();
      // console.log('updatedCanvas values = ',"height= ",height,"width = ", width)
      Object.values(this.state.showUser).forEach((el) => {
        if (el.data.stream && el.data.isVideoStarted) {
          this.updateAttendeeVideo(el.data.userId, el.index);
        } else if (el.data.stream && !el.data.isVideoStarted) {
          this.startAttendeeVideo(el.data.userId, el.index);
        } else if (!el.data.stream && el.data.isVideoStarted) {
          this.stopAttendeeVideo(el.userId);
        }
      });
    }, 1000);
  };

  clearVideoCanvas = () => {
    const { stream } = this.state;
    if (CheckValue(stream)) {
      const canvas = document.querySelector("#participants-canvas");
      stream
        .clearVideoCanvas(canvas)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  zoomRank = (temp, min, max, sliceArr, resize = false) => {
    let checkUpdated = {};
    let {
      showUser,
      isWindowResizing,
      isWindowResizingStopped,
      isParticipantsCanvasHidden,
    } = this.state;
    if (isParticipantsCanvasHidden) {
      return sliceArr;
    }
    let { allUsers } = this.props;
    let newIndex = 0;
    sliceArr.forEach((el, index) => {
      checkUpdated[el.user_id] = {
        index: index,
        status: 2, // 2 for New
        data: el,
      };
      newIndex++;
    });
    // console.log("512");
    if (isWindowResizing) {
      if (!this.state.isUpdatingCanvas) {
        this.setState({ isUpdatingCanvas: true });
        if (Object.values(showUser).length) {
          Object.values({ ...showUser }).forEach((el, index) => {
            if (el.data.isVideoStarted) {
              this.stopAttendeeVideo(el.data.userId);
            }
            delete showUser[el.data.user_id];
          });
        }
        this.clearVideoCanvas();
      } else if (isWindowResizing && isWindowResizingStopped) {
        this.setState({
          isWindowResizing: false,
          isWindowResizingStopped: false,
        });
        this.updateCanvas("zoomRank");
      }
    } else {
      if (Object.values(showUser).length) {
        Object.values(showUser)
          .sort(sortIndex)
          .forEach((el, index) => {
            if (checkUpdated.hasOwnProperty(el.user_id)) {
              if (el.index === checkUpdated[el.user_id].index) {
                checkUpdated[el.user_id].status = 3; // 3 for Same
              } else {
                checkUpdated[el.user_id].status = 1; // 1 for Update
              }
            } else {
              checkUpdated[el.user_id] = {
                index: newIndex,
                status: 0, // 0 for Delete
                data: el.data,
              };
              newIndex++;
            }
          });
      }
    }
    Object.values(checkUpdated)
      .sort(sortIndex)
      .sort(sortStatus)
      .forEach((el) => {
        // console.log(el.data.stream, el.data.stream && !CheckValue(el.data.isVideoStarted), el.data.first_name );
        if (CheckValue(el.data) && CheckValue(el.data.userId)) {
          if (el.status === 1 && !this.state.isUpdatingCanvas) {
            if (!el.data.stream && el.data.isVideoStarted) {
              this.stopAttendeeVideo(el.data.userId);
            } else if (
              (el.data.stream && !el.data.isVideoStarted) ||
              (el.data.stream && !CheckValue(el.data.isVideoStarted))
            ) {
              this.startAttendeeVideo(el.data.userId, el.index);
            } else if (el.data.stream && el.data.isVideoStarted) {
              this.updateAttendeeVideo(el.data.userId, el.index);
            }
          } else if (el.status === 2 && !this.state.isUpdatingCanvas) {
            if (!el.data.stream && el.data.isVideoStarted) {
              this.stopAttendeeVideo(el.data.userId);
            } else if (
              (el.data.stream && !el.data.isVideoStarted) ||
              (el.data.stream && !CheckValue(el.data.isVideoStarted))
            ) {
              this.startAttendeeVideo(el.data.userId, el.index);
            }
          } else if (el.status === 0) {
            this.stopAttendeeVideo(el.data.userId);
            delete showUser[el.data.user_id];
          } else if (el.status === 3 && !this.state.isUpdatingCanvas) {
            if (!el.data.stream && el.data.isVideoStarted) {
              this.stopAttendeeVideo(el.data.userId);
            } else if (
              (el.data.stream && !el.data.isVideoStarted) ||
              (el.data.stream && !CheckValue(el.data.isVideoStarted))
            ) {
              this.startAttendeeVideo(el.data.userId, el.index);
            }
          }
          showUser[el.data.user_id] = {
            user_id: el.data.user_id,
            userId: el.data.userId,
            index: el.index,
            data: el.data,
          };
        } else {
          if (!allUsers.hasOwnProperty(el.data.user_id)) {
            this.stopAttendeeVideo(el.data.userId);
            delete showUser[el.data.user_id];
          }
        }
      });
    temp.splice(min, max);
    temp.forEach((el) => {
      if (el.isVideoStarted) {
        this.stopAttendeeVideo(el.userId);
      }
    });
    // let temp2 = [...sliceArr];
    // Array(9).fill(0).forEach(el => {
    //     temp2.push(...sliceArr);
    // })
    // return temp2;
    return sliceArr;
  };

  render() {
    // return <canvas id='coach_canvas_view' className='coachVideo'></canvas>
    return null;
  }
}

export default ZoomSDK;

const sortIndex = (a, b) => {
  var textA = a["index"];
  var textB = b["index"];
  return textA < textB ? 1 : textA > textB ? -1 : 0;
};
const sortStatus = (a, b) => {
  var textA = a["status"];
  var textB = b["status"];
  return textA < textB ? 1 : textA > textB ? -1 : 0;
};
